import { render } from "./CityEssentialAppsSection.vue?vue&type=template&id=849c9ce2&scoped=true"
import script from "./CityEssentialAppsSection.vue?vue&type=script&lang=js"
export * from "./CityEssentialAppsSection.vue?vue&type=script&lang=js"

import "./CityEssentialAppsSection.vue?vue&type=style&index=0&id=849c9ce2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-849c9ce2"]])

export default __exports__